import React, { useEffect, useState } from "react"
import MetaTags from "react-meta-tags"
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
} from "reactstrap"


import servicesIcon1 from "../../assets/images/services-icon/01.png"
import servicesIcon2 from "../../assets/images/services-icon/02.png"
import servicesIcon3 from "../../assets/images/services-icon/03.png"
import servicesIcon4 from "../../assets/images/services-icon/04.png"

import "chartist/dist/scss/chartist.scss"

import "pages/Dashboard/dashboard.scss"

// services
import ApplicationService from "../../services/applications/Application.service"
import Staff from "services/staff/Staff"
import Trends from "./Trends"

let appService = null
let staffService = new Staff()

// const trendsData = {
//   "Jan": {
//     "imported": "500",
//     "exported": "600",
//     "recycled": "400"
//   },
//   "Feb": {
//     "imported": "600",
//     "exported": "700",
//     "recycled": "450"
//   },
//   "Mar": {
//     "imported": "800",
//     "exported": "750",
//     "recycled": "600"
//   },
//   "Apr": {
//     "imported": "700",
//     "exported": "800",
//     "recycled": "550"
//   },
//   "May": {
//     "imported": "850",
//     "exported": "900",
//     "recycled": "700"
//   },
//   "Jun": {
//     "imported": "900",
//     "exported": "850",
//     "recycled": "800"
//   },
//   "Jul": {
//     "imported": "1000",
//     "exported": "950",
//     "recycled": "900"
//   },
//   "Aug": {
//     "imported": "950",
//     "exported": "1000",
//     "recycled": "850"
//   },
//   "Sep": {
//     "imported": "1100",
//     "exported": "1050",
//     "recycled": "1000"
//   },
//   "Oct": {
//     "imported": "1200",
//     "exported": "1100",
//     "recycled": "1100"
//   },
//   "Nov": {
//     "imported": "1000",
//     "exported": "950",
//     "recycled": "950"
//   },
//   "Dec": {
//     "imported": "800",
//     "exported": "750",
//     "recycled": "750"
//   }
// };


const PlasticsStats = () => {
  const [menu, setMenu] = useState(false)
  const [user, setuser] = useState()
  const [mounted, setmounted] = useState(false)
  const [permissions, setpermissions] = useState()
  const [statistics, setstatistics] = useState()
  const [trendsData, settrendsData] = useState({})

  const toggle = () => {
    setMenu(!menu)
  }

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("authUser"))
    appService = new ApplicationService(user)
    setuser(user)
    // fetch trends
    fetchTrends()
    appService.getRecycledStatistics().then(response => {
      setstatistics(response.data)
    })
    // fetchSearch()
  }, [])

  // const fetchSearch = () => {
  //   const url = "http://apis.rema.gov.rw/api/search?search=REMA-ENV-23-0001751&application_status=SUBMITTED,REVIEWED,UNDER REVIEW,DEPARTMENT APPROVED,SENT_BACK_HoD,SENT_BACK_DG,RETURN TO APPLICANT,DEPARTMENT_REJECTED"
  //   fetch(url).then(response => {
  //     // console.log("Search data ==> ", response)
  //     return response.json()

  //   })
  //   .then(data => {
  //     console.log("Search data ==> ", data)
  //   })
  // }
  const fetchTrends = async () => {
    
    const response = await appService.getPlasticsStats();
    if (response.status) {
      
      settrendsData(response.data)
    }
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Stats | Staff</title>
        </MetaTags>
        <Container fluid>
          <div className="page-title-box">
            <Row className="align-items-center">
              <Col md={8}>
                <h6 className="page-title">Statistics</h6>
                <ol className="breadcrumb m-0">
                  <li className="breadcrumb-item active">
                    Welcome to the Statistics Dashboard
                  </li>
                </ol>
              </Col>
            </Row>
          </div>

          <Row>
            <Col xl={4} md={6}>
              <Card className="mini-stat iconComponent text-white">
                <CardBody>
                  <div className="mb-4">
                    <div className="float-start mini-stat-img me-4">
                      <img src={servicesIcon1} alt="" />
                    </div>
                    <h5 className="font-size-16 text-uppercase mt-0 text-white-50">
                      IMPORTED (Kg)
                    </h5>
                    <h4 className="fw-medium font-size-24">
                      {statistics && statistics.total_imported}
                      <i className="mdi mdi-arrow-up text-success ms-2"></i>
                    </h4>
                    <div className="mini-stat-label bg-warning">
                      <p className="mb-0">|</p>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
            <Col xl={4} md={6}>
              <Card className="mini-stat iconComponent text-white">
                <CardBody>
                  <div className="mb-4">
                    <div className="float-start mini-stat-img me-4">
                      <img src={servicesIcon2} alt="" />
                    </div>
                    <h5 className="font-size-16 text-uppercase mt-0 text-white-50">
                      EXPORTED (Kg)
                    </h5>
                    <h4 className="fw-medium font-size-24">
                      {statistics && statistics.total_exported}
                      <i className="mdi mdi-arrow-down text-danger ms-2"></i>
                    </h4>
                    <div className="mini-stat-label bg-info">
                      <p className="mb-0">|</p>
                    </div>
                  </div>
                  
                </CardBody>
              </Card>
            </Col>
            <Col xl={4} md={6}>
              <Card className="mini-stat iconComponent text-white">
                <CardBody>
                  <div className="mb-4">
                    <div className="float-start mini-stat-img me-4">
                      <img src={servicesIcon3} alt="" />
                    </div>
                    <h5 className="font-size-16 text-uppercase mt-0 text-white-50">
                      RECYCLED (Kg)
                    </h5>
                    <h4 className="fw-medium font-size-24">
                      {statistics && statistics.total_recycled}{" "}
                      <i className="mdi mdi-arrow-up text-success ms-2"></i>
                    </h4>
                    <div className="mini-stat-label bg-success">
                      <p className="mb-0"> |</p>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
            {/* <Col xl={3} md={6}>
              <Card className="mini-stat iconComponent text-white">
                <CardBody>
                  <div className="mb-4">
                    <div className="float-start mini-stat-img me-4">
                      <img src={servicesIcon4} alt="" />
                    </div>
                    <h5 className="font-size-16 text-uppercase mt-0 text-white-50">
                      REJECTED
                    </h5>
                    <h4 className="fw-medium font-size-24">
                      {statistics && statistics.rejected}
                      <i className="mdi mdi-arrow-up text-success ms-2"></i>
                    </h4>
                    <div className="mini-stat-label bg-danger">
                      <p className="mb-0"> |</p>
                    </div>
                  </div>
                  
                </CardBody>
              </Card>
            </Col> */}
          </Row>

          <Row>
            <Trends data={trendsData} />
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default PlasticsStats
